import { FC } from 'react';
import styled from '@emotion/styled';
import { display } from 'styled-system';

const PlusDivider = styled(({ className }) => <span className={className}>{' + '}</span>)`
  ${display};
`;

const NewLineDivider = styled(({ className }) => <br className={className} data-testid="new-line-divider" />)`
  ${display};
`;

const Divider: FC = () => (
  <>
    <PlusDivider display={['none', 'inline']} />
    <NewLineDivider display={['block', 'none']} />
  </>
);

export default Divider;
